<template>
  <navigation-button
    :route="{ name: 'Dashboard' }"
    :style-classes="`btn-secondary ${styleClasses}`"
    text="Dashboard"
    icon="address-card"
    :display-badge="displayBadge"
    :badge-offset-x="badgeOffsetX"
    :badge-offset-y="badgeOffsetY"
    :badge-text="badgeText"
  />
</template>

<script>
import NavigationButton from '@/components/utils/buttons/navigation/NavigationButton';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faAddressCard } from '@fortawesome/free-solid-svg-icons';

library.add(faAddressCard);

export default {
  components: {
    NavigationButton,
  },
  props: {
    displayBadge: Boolean,
    badgeOffsetX: [String, Number],
    badgeOffsetY: [String, Number],
    badgeText: [String, Number],
    styleClasses: String,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/buttons/navigation/DashboardButton.vue